export const getFiscalItemDescription = (row) => {
    const baseDescription = row?.product?.name
        || row?.productNameSnapshot
        || row?.package?.name
        || row?.name
        || "Articolo";
    const variantNames = (Array.isArray(row?.orderProductVariants)
        ? row.orderProductVariants
        : [])
        .map((entry) => entry?.variant?.name || entry?.name)
        .map((name) => String(name || "").trim())
        .filter(Boolean);

    return variantNames.length > 0
        ? `${baseDescription} - ${variantNames.join(" + ")}`
        : baseDescription;
};
